import _get from "lodash/get";
import styled from 'styled-components';
import { rem } from 'polished';
import { baseTheme } from '@luigiclaudio/ga-baseline-ui/base-theme';
import { paragraphStyles } from '@luigiclaudio/ga-baseline-ui/typography';
var FeedbackLabel = styled.div.withConfig({
  displayName: "FeedbackLabel",
  componentId: "i3whzk-0"
})(["", " color:", ";font-weight:700;max-width:", ";text-align:center;"], paragraphStyles, function (_ref) {
  var theme = _ref.theme,
      alertType = _ref.alertType;
  return _get(theme, "base.colors." + alertType, baseTheme.base.colors[alertType]);
}, rem(300));
export default FeedbackLabel;